/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20260611 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Resetable } from '../../resetter/resetable';
import { Syncable } from '../../sync/syncable';
import { Cellphone } from 'src/app/_model/cellphone';
import { IMSId } from 'src/app/_model/ims-object';
import { InitializeAware, InitializeStatus } from '../../initialize/initialize-aware';
import { APILevel } from '../../sync/api-level';

@Injectable()
export abstract class CellphonesService implements Resetable, Syncable, InitializeAware {
  public cellphones$: BehaviorSubject<Cellphone[]>;

  public abstract getCellphoneById(id: IMSId): Cellphone;

  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;

  public abstract presync(): Promise<void>;
  public abstract sync(apiLevel: APILevel, syncKey: string): Promise<void>;
  public abstract postsync(): Promise<void>;

  public initializeStatus$: BehaviorSubject<InitializeStatus>;
  abstract initialize(): Promise<void>;
  abstract initializeCompleted(): Promise<void>;
}
